export const DEFAULT_PUBLIC_LOCALE = 'hy';
export const DEFAULT_I18N_LANGUAGE = 'am';
export const LOCALE_STORAGE_KEY = 'rmg.locale';

export const PUBLIC_LOCALES = ['hy', 'ru', 'en'];

export const PUBLIC_TO_I18N_LANGUAGE = {
  hy: 'am',
  am: 'am',
  ru: 'ru',
  en: 'en',
};

export const I18N_TO_PUBLIC_LOCALE = {
  am: 'hy',
  hy: 'hy',
  ru: 'ru',
  en: 'en',
};

export const HREFLANG_BY_LOCALE = {
  hy: 'hy-AM',
  ru: 'ru',
  en: 'en',
};

export function normalizePublicLocale(locale) {
  if (!locale) {
    return DEFAULT_PUBLIC_LOCALE;
  }

  const normalized = String(locale).toLowerCase();

  if (normalized === 'am') {
    return 'hy';
  }

  return PUBLIC_LOCALES.includes(normalized) ? normalized : DEFAULT_PUBLIC_LOCALE;
}

export function getPublicLocaleFromI18nLanguage(language) {
  return I18N_TO_PUBLIC_LOCALE[language] || normalizePublicLocale(language);
}

export function getI18nLanguageFromPublicLocale(locale) {
  return PUBLIC_TO_I18N_LANGUAGE[normalizePublicLocale(locale)] || DEFAULT_I18N_LANGUAGE;
}

export function getLocaleFromPath(pathname = window.location.pathname) {
  const firstSegment = pathname.split('/').filter(Boolean)[0];
  return PUBLIC_LOCALES.includes(firstSegment) ? firstSegment : null;
}

export function getSavedPublicLocale() {
  if (typeof window === 'undefined') {
    return DEFAULT_PUBLIC_LOCALE;
  }

  return normalizePublicLocale(window.localStorage.getItem(LOCALE_STORAGE_KEY));
}

export function persistPublicLocale(locale) {
  if (typeof window === 'undefined') {
    return;
  }

  window.localStorage.setItem(LOCALE_STORAGE_KEY, normalizePublicLocale(locale));
}

export function getInitialPublicLocale() {
  if (typeof window === 'undefined') {
    return DEFAULT_PUBLIC_LOCALE;
  }

  return normalizePublicLocale(getLocaleFromPath() || getSavedPublicLocale());
}

export function getInitialI18nLanguage() {
  return getI18nLanguageFromPublicLocale(getInitialPublicLocale());
}

export function getCurrentPublicLocale(i18nLanguage) {
  const urlLocale = typeof window !== 'undefined' ? getLocaleFromPath() : null;
  return normalizePublicLocale(urlLocale || getPublicLocaleFromI18nLanguage(i18nLanguage));
}

export function getPathWithoutLocale(pathname = window.location.pathname) {
  const parts = pathname.split('/').filter(Boolean);

  if (parts.length && PUBLIC_LOCALES.includes(parts[0])) {
    parts.shift();
  }

  return parts.length ? `/${parts.join('/')}` : '';
}

export function buildLocalizedPath(locale, pathname = window.location.pathname, hash = window.location.hash) {
  const publicLocale = normalizePublicLocale(locale);
  const rest = getPathWithoutLocale(pathname);
  return `/${publicLocale}${rest}${hash || ''}`;
}

export function ensureLocalizedPath(locale) {
  if (typeof window === 'undefined') {
    return;
  }

  if (getLocaleFromPath()) {
    return;
  }

  const localizedPath = buildLocalizedPath(locale || getInitialPublicLocale());
  window.history.replaceState({}, document.title, localizedPath);
}

export function switchToLocaleUrl(languageOrLocale) {
  if (typeof window === 'undefined') {
    return;
  }

  const publicLocale = normalizePublicLocale(getPublicLocaleFromI18nLanguage(languageOrLocale));
  const localizedPath = buildLocalizedPath(publicLocale);
  window.history.replaceState({}, document.title, localizedPath);
}
